import {
  IAddress,
  TAddressImageUpload,
  TAddressUpdate,
  TAddressCreate,
} from '@@types/address';
import { TResponseType } from '@@types/base';
import { TNaverAddress, TNaverReverseAddress } from '@@types/naver';
import instance from '@apis/instance';
import { invalidateGetResponse } from 'utils/common';

const BASE_ADDRESS_URI = '/address';

const fetchAddresses = () =>
  invalidateGetResponse<IAddress[]>({ url: BASE_ADDRESS_URI });

const createAddress = (addressData: TAddressCreate) =>
  instance.post(BASE_ADDRESS_URI, addressData);

const updateAddress = (addressData: TAddressUpdate) =>
  instance.patch(BASE_ADDRESS_URI, addressData);

const CURRENT_ADDRESS_URI = `${BASE_ADDRESS_URI}/current`;

const fetchCurrentAddress = () =>
  invalidateGetResponse<{ address: IAddress }>({ url: CURRENT_ADDRESS_URI });

const changeCurrentAddress = (addressId: { id: string }) =>
  instance.patch(CURRENT_ADDRESS_URI, addressId);

const deleteAddress = (addressId: string) =>
  instance.delete(`${BASE_ADDRESS_URI}/${addressId}`);

const uploadAddressImage = (imageData: TAddressImageUpload) =>
  instance.patch(`${BASE_ADDRESS_URI}/image`, imageData);

const checkRoadviewImage = (addressId: string) =>
  instance.get<TResponseType<{ roadviewImage: string }>>(
    `${BASE_ADDRESS_URI}/roadview-image/${addressId}`,
  );

const searchGeocode = (address: string) =>
  invalidateGetResponse<TNaverAddress>({
    url: `${BASE_ADDRESS_URI}/search/geocode`,
    options: { params: { address } },
  });

const searchReverseGeocode = (latitude: string, longitude: string) =>
  invalidateGetResponse<TNaverReverseAddress>({
    url: `${BASE_ADDRESS_URI}/search/reverse-geocode`,
    options: { params: { lat: latitude, lng: longitude } },
  });

export default {
  fetchAddresses,
  createAddress,
  updateAddress,
  fetchCurrentAddress,
  changeCurrentAddress,
  deleteAddress,
  uploadAddressImage,
  checkRoadviewImage,
  searchGeocode,
  searchReverseGeocode,
};
